import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eeb878f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }

import { reactive } from 'vue'

export interface SiderItemProps {
  title: string,
  children: Partial<SiderItemProps>[],
  link: string
}

export interface SiderProProps {
  title: string,
  siders: Partial<SiderItemProps>[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const initProps: Partial<SiderProProps> = {
  title: '云服务器列表',
  siders: [
    { title: '总览' },
    { title: '事件' }
  ]
}

const props = initProps

const state = reactive({
  active: '总览'
})

const changeSider = (records: SiderItemProps) => state.active = records.title


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "sider-pro" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { class: "sider-pro-title" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(props).title), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).siders, (item) => {
        return (_openBlock(), _createBlock(_component_a_col, {
          class: "sider-pro-item",
          key: item.title,
          onClick: ($event: any) => (changeSider(item))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['title', state.active == item.title ? 'active' : ''])
            }, _toDisplayString(item.title), 3)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})